module.exports = __webpack_public_path__ + "static/hawk-zoom-9b9642665921fbda49c9a03192c613fd.jpg";